export default function hasValidRoomTypeCodes(roomTypes) {
	for (let roomKey in roomTypes) {
		const currentRoom = roomTypes[roomKey]

		if (
			currentRoom.roomTypeCode === null ||
			currentRoom.roomTypeCode === ''
		)
			return false
	}
	return true
}


// WEBPACK FOOTER //
// ./src/utilities/content/hasValidRoomTypeCodes.js